import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {endpoints} from '../common/api-endpoints';
import {DataService} from './data.service';

export interface IExportSiteTaskData {
  siteId: string
  percent: number;
  DownloadState: NodeDownloadState;
}

export interface NodeDownloadState {
  id: string;
  totalBytes: number;
  bytesAdded: number;
  filesAdded: number;
  totalFiles: number;
  status: string;
}

export interface ITask<ITaskData> {
  creator: string;
  type: TaskTypes;
  data: ITaskData;
  startedAt: Date | null;
  endedAt: Date | null;
  status: TaskStatus;
}

export enum TaskTypes {
  ExportSite = 'Export Site'
}

export enum TaskStatus {
  Pending = 'pending',
  Failed = 'failed',
  Done = 'done',
}

@Injectable({
  providedIn: 'root'
})
export class TaskService extends DataService<ITask<any>> {
  constructor(httpClient: HttpClient) {
    super(endpoints.task, httpClient);
  }
}
